import { withStyles, WithStyles } from '@material-ui/styles'
import { StandardButton } from 'components/common/elements/buttons'
import React from 'react'
import { nextButtonStyles } from './nextButton.style'
import ArrowIcon from '../../../icons/ArrowIcon.svg'

interface INextButton {
  text: string
  onClick: () => void
}

type NextButtonProps = INextButton & WithStyles<typeof nextButtonStyles>

class NextButtonCls extends React.Component<NextButtonProps> {
  render() {
    const { classes, text, onClick } = this.props
    return (
      <StandardButton
        className={classes.btn}
        dataAt="nextButtonSnb"
        onClick={onClick}
        hoverOverlayClassName="btn-no-hover-overlay"
      >
        <img className={classes['btn-icon']} src={ArrowIcon} alt="arrow-icon" />
        {text}
      </StandardButton>
    )
  }
}

export default withStyles(nextButtonStyles, { name: 'NextButton' })(
  NextButtonCls
)
